"use client";

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from "@apollo/client/react";
import { GET_TESTIMONIALS } from "@/graphql/queries/testimonials";
import { useState } from "react";
import { Section } from "@/components/section";
import { Box } from "@/components/ui/box";
import { SeoHeading } from "@/components/common/seo-heading";
import { Text } from "@/components/ui/text";
import { TestimonialCard } from "@/components/common/testimonial-card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
type TestimonialsProps = {
  section: PageSections;
  data: {
    heading: string;
    seoHeading: string;
    description?: string;
  };
};
const filterOptions = [{
  label: "All testimonials ",
  value: ""
}, {
  label: "Course testimonials ",
  value: "service"
}, {
  label: "Category testimonials ",
  value: "category"
}];
export default function Testimonials(t0) {
  const $ = _c(40);
  const {
    section,
    data
  } = t0;
  const [load, setLoad] = useState(9);
  const [filter, setFilter] = useState("");
  const {
    data: testimonialsData
  } = useSuspenseQuery(GET_TESTIMONIALS);
  let t1;
  if ($[0] !== testimonialsData.testimonials.length) {
    t1 = () => {
      setLoad(prevLoad => testimonialsData?.testimonials?.length > prevLoad ? prevLoad + 6 : prevLoad);
    };
    $[0] = testimonialsData.testimonials.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLoadMore = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => {
      setFilter(value as "category" | "service" | "");
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleFilterChange = t2;
  const t3 = section.sectionId;
  const t4 = section.sectionClass;
  let t5;
  if ($[3] !== data.heading || $[4] !== data.seoHeading) {
    t5 = <SeoHeading heading={data.heading} seoHeading={data.seoHeading} />;
    $[3] = data.heading;
    $[4] = data.seoHeading;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value_0 => handleFilterChange(value_0);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SelectTrigger className="w-full max-w-48"><SelectValue /></SelectTrigger>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SelectContent alignItemWithTrigger={false}><SelectGroup>{filterOptions.map(_temp)}</SelectGroup></SelectContent>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== filter) {
    t9 = <Select items={filterOptions} defaultValue={filter} value={filter} onValueChange={t6}>{t7}{t8}</Select>;
    $[9] = filter;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t5 || $[12] !== t9) {
    t10 = <Box className="flex justify-between">{t5}{t9}</Box>;
    $[11] = t5;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== data.description) {
    t11 = data.description && <Text className="text-muted-foreground mb-4">{data.description}</Text>;
    $[14] = data.description;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = load >= testimonialsData?.testimonials?.length;
  let t13;
  if ($[16] !== t12) {
    t13 = cn("after:from-background relative mt-14 w-full after:absolute after:inset-x-0 after:-bottom-2 after:h-96 after:bg-linear-to-t", {
      "after:h-0": t12
    });
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      columnGap: "20px"
    };
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== filter || $[20] !== load || $[21] !== testimonialsData.testimonials) {
    let t16;
    if ($[23] !== filter) {
      t16 = item_0 => {
        if (filter === "service") {
          return item_0.service !== null;
        }
        if (filter === "category") {
          return item_0.category !== null;
        }
        return true;
      };
      $[23] = filter;
      $[24] = t16;
    } else {
      t16 = $[24];
    }
    t15 = testimonialsData.testimonials.filter(t16).slice(0, load).map(_temp2);
    $[19] = filter;
    $[20] = load;
    $[21] = testimonialsData.testimonials;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[25] !== t15) {
    t16 = <div className="columns-1 gap-5 md:columns-2 lg:columns-3" style={t14}>{t15}</div>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13 || $[28] !== t16) {
    t17 = <div className={t13}>{t16}</div>;
    $[27] = t13;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = load >= testimonialsData?.testimonials?.length;
  let t19;
  if ($[30] !== handleLoadMore || $[31] !== t18) {
    t19 = <div className="py-8 text-center"><Button onClick={handleLoadMore} disabled={t18}>Load more</Button></div>;
    $[30] = handleLoadMore;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== section.sectionClass || $[34] !== section.sectionId || $[35] !== t10 || $[36] !== t11 || $[37] !== t17 || $[38] !== t19) {
    t20 = <Section id={t3} className={t4}>{t10}{t11}{t17}{t19}</Section>;
    $[33] = section.sectionClass;
    $[34] = section.sectionId;
    $[35] = t10;
    $[36] = t11;
    $[37] = t17;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
}
function _temp2(testimonial, idx) {
  const displayIdx = idx % 3 * 3 + Math.floor(idx / 3);
  return <TestimonialCard key={testimonial.id} avatar={testimonial.avatar_img} name={testimonial.userName} company={testimonial.companyName} quote={testimonial.comments} rating={testimonial.fiveStarRating} role={testimonial.jobTitle} className={cn("mb-5 max-w-full", displayIdx > 3 && displayIdx <= 5 && "hidden md:block", displayIdx > 5 && "hidden lg:block")} />;
}
function _temp(item) {
  return <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>;
}